import { Translate, withLocalize } from "react-localize-redux";
import Sheet from "react-modal-sheet";
import translations from "../../translations/menuSheet.json";
import { Link } from "react-router-dom/cjs/react-router-dom";
import DefaultProfilePhoto from "../../assets/fallbacks/default-profile-photo.png";
import LogoutIcon from "../../assets/images/icons/logout-icon.svg";
import BaseButton from "wallet-elementkit/dist/elementKit/baseButton/BaseButton";

import Dropdown from "react-bootstrap/Dropdown";
import { langs } from "../../translations/translateJsonFile";
import "../../styles/components/menuSheet/menuSheetMobile.scss";
import SheetFooter from "../sheetFooter/SheetFooter";
import styled from "styled-components";
import { useLayoutEffect } from "react";
import { Subdomains } from "wallet-elementkit/dist/constants";
import { getMasterConfig } from "wallet-elementkit/dist/constants/master";

const StyledMenuSheetMobile = styled.div`
	${(props) => `
    .customizable-text {
      color: ${props.primaryColor} !important;
    }
	.customizable-icon {
		fill: ${props.primaryColor} !important;
	}
	.customizable-bg {
		background: ${props.primaryColor + "10"} !important;
	}

	.customizable-divider{
		background: ${props.primaryColor} !important;
	}
	.active {
		.customizable-icon {
			fill: #fff !important;
		}
	}
  `};
`;
const MenuSheetMobile = (props) => {
	useLayoutEffect(() => {
		props.addTranslation(translations);
	}, []);

	const config = getMasterConfig();

	const userWalletsFiltered =
		config.subDomain === Subdomains.bitdefender
			? []
			: props.userMeta.allUserWallets.filter((org) => !org.isActive);

	return (
		<Sheet
			isOpen={props.sheetOpen}
			onClose={props.onClose}
			initialSnap={580}
			className="menu-sheet-mobile"
		>
			<Sheet.Container>
				<Sheet.Header />
				<Sheet.Content>
					<StyledMenuSheetMobile
						primaryColor={props.config?.primaryColor}
						backgroundColor={props.config?.primaryColor}
					>
						<div className="sheet-content-header customizable-bg">
							<Link
								to={
									props.activeLanguage
										? `/${props.activeLanguage.code}/profile/${props.userMeta.user.username}/`
										: `/en/profile/${props.userMeta.user.username}/`
								}
								style={{ width: "100%" }}
								onClick={props.onClose}
							>
								<div className="profile-row-mobile">
									{props.userMeta.user.profile_url ? (
										<img
											src={props.userMeta.user.profile_url}
											className="profile-img"
											alt="User Profile"
											height="80"
											width="80"
											onClick={props.onClose}
										/>
									) : (
										<img
											src={DefaultProfilePhoto}
											className="profile-img"
											alt="Default User Profile"
											height="80"
											width="80"
											onClick={props.onClose}
										/>
									)}
									<div className="profile-info-col" onClick={props.onClose}>
										<span className="name-text">
											{props.userMeta.user.name}
										</span>
										<span className="email-text customizable-text">
											{props.userMeta.user.email}
										</span>
									</div>
								</div>
							</Link>
							<div className="hz-divider customizable-divider" />
							<div className="wallet-container">
								<div className="org-logo-wrapper">
									<img
										src={
											props.userMeta.allUserWallets.filter(
												(org) => org.isActive
											)[0]?.organizationLogo || props.config.logoLink
										}
										className="org-logo"
										alt="org-logo"
									/>
								</div>
								<span className="org-title">
									{props.userMeta.allUserWallets.filter(
										(org) => org.isActive
									)[0]?.organizationName || props.config.organizationName}
								</span>
							</div>
							<div className="hz-divider customizable-divider" />
						</div>

						<div className="sheet-content-body flex-column ai-c">
							<div className="other-wallets">
								{
									// allUserWalletsmap from index 1
									userWalletsFiltered.map((wallet, index) => {
										return (
											<>
												<div
													className="wallet-container"
													key={`wallet-${index}`}
													onClick={() => {
														props.handleWalletSwitch(wallet.domain);
													}}
												>
													<div className="org-logo-wrapper">
														<img
															src={wallet.organizationLogo}
															className="org-logo"
															alt="org-logo"
														/>
													</div>
													<span className="org-title">
														{wallet.organizationName}
													</span>
												</div>
												<div className="hz-divider" />
											</>
										);
									})
								}
							</div>

							{config.subDomain !== Subdomains.bitdefender && (
								<Dropdown
									id="dropdown-basic-button-mobile"
									style={{
										marginTop: "16px",
									}}
									onSelect={(langCode) => {
										props.changeLang(langCode);
									}}
								>
									<Dropdown.Toggle>
										<BaseButton
											type="secondary"
											size="small"
											loading={false}
											className="lang-btn"
											height={37}
											width={352}
										>
											<span>
												{props.activeLanguage ? props.activeLanguage.name : ""}
											</span>
										</BaseButton>
									</Dropdown.Toggle>
									<Dropdown.Menu>
										{langs.certificateLanguages.map((language) => (
											<Dropdown.Item
												eventKey={language.code}
												key={language.code}
											>
												{language.name}
											</Dropdown.Item>
										))}
									</Dropdown.Menu>
								</Dropdown>
							)}
							<BaseButton
								type="danger"
								size="small"
								className="logout-btn"
								height={37}
								styles={{ marginTop: "16px" }}
								width={352}
								loading={false}
								onClickAction={props.logout}
							>
								<img
									src={LogoutIcon}
									alt="Verified Logout"
									style={{ marginRight: "10px" }}
								/>
								<Translate id="logout" />
							</BaseButton>
						</div>

						{config.subDomain !== Subdomains.bitdefender && (
							<div className="sheet-content-footer flex-column ai-c">
								<SheetFooter />
							</div>
						)}
					</StyledMenuSheetMobile>
				</Sheet.Content>
			</Sheet.Container>
			<Sheet.Backdrop />
		</Sheet>
	);
};

export default withLocalize(MenuSheetMobile);
